import axios from '../../axios';

const path = 'tags';

const service = {
  async getAllTags() {
    return axios({ method: 'get', url: `/${path}/all` });
  },

  async fetchTags(params) {
    return axios({ method: 'get', url: `/${path}`, params });
  },

  async fetchTag(id) {
    return axios({ method: 'get', url: `/${path}/${id}` });
  },

  async searchTags(params) {
    return axios({ method: 'get', url: `/${path}/search`, params });
  },

  async addTag(payload) {
    return axios({ method: 'post', url: `/${path}/create`, data: payload });
  },

  async updateOne(id, payload) {
    return axios({ method: 'put', url: `/${path}/${id}`, data: payload });
  },

  async updateMany(payload) {
    return axios({ method: 'put', url: `/admin/${path}`, data: payload });
  },

  async deleteTags(ids) {
    return axios({ method: 'delete', url: `${path}/archive`, data: { ids } });
  }
};

export default service;
